import styled from 'styled-components';
import { MMediaCarouselCarouselStyle } from './MMediaCarousel.types';

export const Wrapper = styled.div<{ carouselStyle: MMediaCarouselCarouselStyle; hover: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: ${({ carouselStyle }) =>
    carouselStyle === MMediaCarouselCarouselStyle.Standard ? 'var(--t-images-border-radius, 14px)' : '8px'};

  @media (min-width: 768px) {
    height: -webkit-fill-available;
  }

  ${({ hover }) =>
    hover &&
    `
    transition: transform 0.3s ease;
    
    &:hover {
      transform: scale(1.02);
    }
  `}
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const SlideContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    height: -webkit-fill-available;

    picture {
      height: -webkit-fill-available;
    }
  }

  img {
    width: 100%;

    @media (min-width: 768px) {
      object-fit: cover;
      object-position: center center;
      height: 100%;
    }
  }
`;

export const ArrowsWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  pointer-events: none;
  z-index: 10;
`;

export const ArrowLeft = styled.div`
  pointer-events: auto;
`;

export const ArrowRight = styled.div`
  pointer-events: auto;
`;

export const ControlsWrapper = styled.div`
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
`;
